import i18n from '@/i18n';

export default function useI18n() {
  return {
    translate: i18n.global.t,
    t: i18n.global.t,
  };
}
